// extracted by mini-css-extract-plugin
export var labelWrapper = "_ft-0";